import { ListItem } from '@mui/material';
import { Draggable} from 'react-beautiful-dnd';
import { ReactComponent as Dragdots } from "assets/Dragdots.svg";
import { tokens } from 'styles/Tokens';
import Typography from './Typography';


interface Item  {
    id: string,
    name: string
}

interface DraggableListItemProps {
  item: Item;
  index: number;
  length: number;
};

const DraggableListItem = ({ item, index, length }: DraggableListItemProps) => {
  return (
    <Draggable draggableId={`id${item.id}`} index={index}>
      {(provided: any, snapshot: any) => (
        <ListItem
          sx = {{
            background: snapshot.isDragging ? tokens.Draggable.General.DraggedItem : tokens.Draggable.General.Background, 
            borderBottom: `1px solid ${tokens.Draggable.General.Border}`, 
            padding: '8px 16px', 
            color: snapshot.isDragging ? tokens.Draggable.General.DraggedText : tokens.Draggable.General.Text,
            fontSize: '14px',
            height: '56px',
            borderTopLeftRadius: (index === 0) ? '5px' : '0',
            borderTopRightRadius: (index === 0) ? '5px' : '0',
            borderBottomLeftRadius: (index === length - 1) ? '5px' : '0',
            borderBottomRightRadius: (index === length - 1) ? '5px' : '0',
           }}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          <Dragdots />
          <Typography sx = {{
            paddingLeft: '20px', 
            whiteSpace: 'nowrap', 
            overflow: 'hidden', 
            textOverflow: 'ellipsis'
            }}
            variant = "body2"
            showBold
            >{item.name}</Typography>
        </ListItem>
      )}
    </Draggable>
  );
};

export default DraggableListItem;